import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/trademark-questions-and-answers/[category]/[question]/TrademarkQAQuestion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
